import * as _ from 'lodash';

export function hasPermissionForAttachment(attachment, userGroups: string[]) {
  let hasPermission = false;

  if (attachment.groups && userGroups) {
    for (let i = 0, userGroupLength = userGroups.length; i < userGroupLength; i++) {
      if (attachment.groups.indexOf(userGroups[i]) > -1) {
        hasPermission = true;
        break;
      }
    }
  }

  return hasPermission;
}

export const ATTACHMENT_TYPES_UTIL = [
  'attachments',
  'refModelAttachments',
  'requirementAttachments',
  'storyAttachments'
  // 'orgModelAttachments' // we have a separate icon for this
];

export function filterAttachmentsUtil(attachments = [], userGroups: string[]) {
  return _.filter(attachments, item => hasPermissionForAttachment(item, userGroups));
}

export function someAttachmentsPresent(activity) {
  return ATTACHMENT_TYPES_UTIL.some((type: string) => !_.isEmpty(activity[type]));
}

export function isUrlAttachment(attachment) {
  return _.includes(['url_entry', 'url'], attachment.type);
}
